import { selectedOptions } from "~/lib/shopify/constants"
import { objectValues } from "~/utils/object-values"

export function findOptionIndex(option: string) {
  return objectValues(selectedOptions).findIndex((el) => el.includes(option))
}
